import script from "./headermenu.vue?vue&type=script&setup=true&lang=js"
export * from "./headermenu.vue?vue&type=script&setup=true&lang=js"

import "./headermenu.vue?vue&type=style&index=0&id=7b919512&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b919512"]])

export default __exports__